import React from 'react';

const RelatedKnowledge = () => {
  const knowledgeItems = [
    {
      title: "BRAF Mutation",
      items: [
        "3 new treatment options",
        "Potential clinical trial match"
      ]
    },
    {
      title: "Immunotherapy",
      items: [
        "Recent trial results (2 weeks ago)"
      ]
    },
    {
      title: "Adjunct Therapies",
      items: [
        "Recommendations for side effect management",
        "NCCN guideline updates"
      ]
    },
    {
      title: "Clinical Trials",
      items: [
        "2 potential matches",
        "Phase II NCT04832958"
      ]
    }
  ];
  
  return (
    <div className="bg-gray-200 p-4 h-full">
      <h2 className="text-lg font-medium text-gray-700 mb-4">Related Knowledge:</h2>
      
      <div className="space-y-4">
        {knowledgeItems.map((item, index) => (
          <div key={index} className="bg-white p-3 rounded shadow">
            <h3 className="font-medium text-gray-800 mb-2">{item.title}</h3>
            <ul className="space-y-1">
              {item.items.map((bullet, bulletIndex) => (
                <li key={bulletIndex} className="text-gray-700 flex items-start">
                  <span className="mr-1">•</span> {bullet}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelatedKnowledge;